import { graphql } from '../../../graphql/generated';

export const LAB_QUERY = graphql(`
  query BasedataLab($id: ID!) {
    lab(id: $id) {
      id
      name
      shortName
      longName
      meAddress
      city
      email
      fax
      phone
      street
      zip
      zplLabelTemplate
      zplLabelWidth
      zplLabelHeight
      zplSpecialLabelTemplate
      zplSpecialLabelWidth
      zplSpecialLabelHeight
      newReorderRunningNumber
      diagnoseRequired
      pickupTransferDocument
      printPartnerLab1Params
      printPartnerLab2Params
      printPartnerLab3Params
      printPartnerLab4Params
      printPartnerLab5Params
      pl1Name
      pl2Name
      pl3Name
      pl4Name
      pl5Name
      runningNumber
      invoiceCounter
      elgaOptOut
      elgaOptOutText
      aiEnabled
      aiSystemPromptExtension
    }
  }
`);

export const UPDATE_LAB_MUTATION = graphql(`
  mutation UpdateLab($id: ID!, $input: LabInput!) {
    updateLab(id: $id, input: $input) {
      id
    }
  }
`);
